
export const INIT_JOBS = "INIT_JOBS"
export const ADD_FILTER = "ADD_FILTER"
export const REMOVE_FILTER = "REMOVE_FILTER"
export const CLEAR_FILTERS = "CLEAR_FILTERS"